import { ViteSSG } from "vite-ssg";
import ui from "@nuxt/ui/vue-plugin";
import App from "./app.vue";
import { routes, scrollBehavior } from "./router";
import { createAppI18n, type AppLocale } from "@/library/i18n";
import { DEFAULT_LOCALE } from "@/seo/routes-manifest";
import { initPostHog } from "@/lib/posthog";
import { loadFonts } from "@/lib/fonts";
import "@/assets/styles/main.css";
import "@/assets/styles/blog.css";

export const createApp = ViteSSG(App, { routes, scrollBehavior }, ({ app, router }) => {
  app.use(ui);

  const i18n = createAppI18n(DEFAULT_LOCALE);
  app.use(i18n);

  router.beforeEach((to) => {
    const locale = to.meta?.locale as AppLocale | undefined;
    if (locale && i18n.global.locale.value !== locale) {
      i18n.global.locale.value = locale;
    }
  });

  loadFonts();
  initPostHog(router);
});
